import React from 'react';

import styles from '~/components/plans/bundles-page/plan-bundle-page.module.scss';

const CancelBadge = () => (
  <div className={styles.cancelBadge}>
    <img
      alt="Sunday guarantee badge"
      src="/icons/sunday-guarantee-badge-green-rotate.svg"
      height={75}
      width={75}
    />
    <div className={styles.cancelTextWrapper}>
      <p className={styles.cancelText}>Guaranteed results.</p>
      <p className={styles.cancelText}>Cancel anytime.</p>
    </div>
  </div>
);

export default CancelBadge;
